import * as React from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { animated } from 'react-spring'

const StyledDiv = styled(animated.div)`
  display: flex;
  align-items: center;
  cursor: pointer;
  background: rgba(30, 30, 30, 0);
  color: white;
  border-radius: 10px;
  font-weight: 700;
  margin-right: 15px;

  @media (min-width: 43em) {
    padding: 0 15px;
    margin-left: 15px;
    margin-right: 0;
  }
`

const Trending = (): JSX.Element => {
  const router = useRouter()

  const handleTrendingClick = async (): Promise<void> => {
    router.push('/trending')
  }

  return <StyledDiv onClick={handleTrendingClick}>Trending</StyledDiv>
}

export default Trending
